import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Paper,
  Divider,
  IconButton,
  Select,
  MenuItem,
  Stack,
  Menu,
  Pagination,
  PaginationItem,
  Grid,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import ViewButton from "../../assets/icons/ViewButton.svg";
import ArrowDown from "../../assets/icons/ArrowDown.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";
import { getRepairsList } from "../../redux/actions/repairsAction";
import moment from "moment";
import RepairsViewModel from "./RepairsViewModel";
import GenerateRepairId from "../../utils/GenerateRepairId";
import CalanderActive from "../../assets/icons/CalanderActive.svg";
import { DateEditCalendar } from "../CommonComponent/DateEditCalendar";
import noData from "../../assets/images/Group 688.png";
import { TOTALLIMIT } from "../../utils/localStorage";
import { toast } from "react-toastify";

const RepairsContent = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state?.user?.isLoading);
  const userData = useSelector((state) => state?.user?.userData);

  const departmentMasterData = useSelector(
    (state) => state?.masters?.departmentMasterData
  );

  const vesselMasterData = useSelector(
    (state) => state?.masters?.vesselMasterData
  );
  const [isRepairsViewModel, setIsRepairsViewModel] = useState(false);
  const [repairDeffectRowData, setRepairDeffectRowData] = useState("");
  const [RepairsType, setRepairsType] = useState("");
  const currentYear = new Date().getFullYear();
  const [startDate, setStartDate] = useState(
    moment(userData?.createdAt).format("DD MMM, YYYY")
  );
  const [endDate, setEndDate] = useState(moment().format("DD MMM, YYYY"));
  const [anchorEl, setAnchorEl] = useState();
  const [anchorElEnd, setAnchorElEnd] = useState();
  const open = Boolean(anchorEl);
  const openEnd = Boolean(anchorElEnd);
  const [isPaginationLimit, setIsPaginationLimit] = useState(10);
  const [VesselName, setVesselName] = useState("");
  const [Department, setDepartment] = useState("");

  const handleChangeDepartment = (event) => {
    setDepartment(event.target.value);
  };

  const handleChangeVesselName = (event) => {
    setVesselName(event.target.value);
  };
  const handleChangeIsPaginationLimit = (event) => {
    setIsPaginationLimit(event.target.value);
  };

  const handleCloseRepairsViewModel = (e) => {
    setIsRepairsViewModel(false);
  };

  const handleClick = (event) => {
    setAnchorElEnd(null);
    setAnchorEl(event.currentTarget);
  };

  const handleClickEnd = (event) => {
    setAnchorEl(null);
    setAnchorElEnd(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElEnd(null);
    setAnchorEl(null);
  };

  const handleCloseEnd = () => {
    setAnchorElEnd(null);
    setAnchorEl(null);
  };

  const handleSaveDateStart = (value) => {
    const formattedStartDate = moment(value, "YYYY-MM-DD").format(
      "DD MMM, YYYY"
    );
    setStartDate(formattedStartDate);
  };

  const handleSaveDateEnd = (value) => {
    const formattedEndDate = moment(value, "YYYY-MM-DD").format("DD MMM, YYYY");
    setEndDate(formattedEndDate);
  };

  const formatRepairId = (
    vesselName,
    departmentName,
    checklistType,
    displayId
  ) => {
    const vesselPrefix = vesselName?.slice(0, 3).toUpperCase() || "XXX";
    const departmentPrefix = departmentName?.charAt(0) || "X";
    const checklistTypePrefix = checklistType?.charAt(0) || "X";
    const year = new Date().getFullYear() || "YYYY";
    const formattedDisplayId = String(displayId).padStart(3, "0") || "000";

    return `${vesselPrefix}/${departmentPrefix}/${year}/${checklistTypePrefix}${formattedDisplayId}`;
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const offset = currentPage - 1;
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    if (moment(endDate).isSameOrAfter(startDate)) {
      dispatch(
        getRepairsList({
          vessel_id: userData?.vessel_id ? userData?.vessel_id : VesselName,
          offset: offset,
          limit: isPaginationLimit,
          department_id: Department,
          startDate: moment(startDate).format("YYYY-MM-DDTHH:mm:ss"),
          endDate: moment(endDate)
            .add(23, "hours") // Add 0 hours
            .add(59, "minutes") // Add 0 minutes
            .add(0, "seconds")
            .format("YYYY-MM-DDTHH:mm:ss"),
        })
      );
    } else {
      toast.error("End date cannot be before start date");
    }
  }, [
    userData?.vessel_id,
    VesselName,
    Department,
    startDate,
    endDate,
    offset,
    isPaginationLimit,
  ]);

  const repairstData = useSelector((state) => state?.repairs?.repairstData);
  const repairstDataPagination = useSelector(
    (state) => state?.repairs?.repairstPaginationData
  );

  const hasPermission = (userPermissions, screenName) => {
    const permission = userPermissions?.find(
      (permission) =>
        permission?.screen?.name === screenName && permission?.screen?.active
    );

    if (permission?.active) {
      if (permission) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  return (
    <>
      {isRepairsViewModel && (
        <RepairsViewModel
          isRepairsViewModel={isRepairsViewModel}
          handleCloseRepairsViewModel={handleCloseRepairsViewModel}
          repairDeffectRowData={repairDeffectRowData}
        />
      )}
      <Paper
        sx={{
          width: "auto",
          height: "auto",
          overflow: "auto",
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            height: "80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "20px",
            overflow: "auto",
            width: "auto",
            "&::-webkit-scrollbar": {
              width: "5px",
              height: "3px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#20724E",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#E5F1EB",
            },
          }}
        >
          <Box>
            <Typography
              sx={{
                ml: 2,
                fontSize: "18px",
                fontWeight: 600,
                color: "#212121",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              Repairs
            </Typography>
          </Box>
          <Box sx={{ display: "flex" }}>
            {userData?.role?.name === "VESSEL_ADMIN" ||
            userData?.vessel_id !== null ? (
              ""
            ) : (
              <Select
                value={VesselName}
                onChange={handleChangeVesselName}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                IconComponent={() => (
                  <Box
                    sx={{
                      marginRight: "10px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={ArrowDown}
                      alt="Custom Icon"
                      width="16"
                      height="24"
                    />
                  </Box>
                )}
                sx={{
                  height: "37px",
                  width: "11rem",
                  color: "#20724E",
                  fontWeight: "bold",
                  borderRadius: "10px",
                  backgroundColor: "#E5F1EB",
                  border: "none",
                  mr: 2,
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #E5F1EB",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                <MenuItem value="">Vessel Name</MenuItem>
                {vesselMasterData?.map((row) => (
                  <MenuItem value={row?.id}>{row?.name}</MenuItem>
                ))}
              </Select>
            )}
            <Select
              value={Department}
              onChange={handleChangeDepartment}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              IconComponent={() => (
                <Box
                  sx={{
                    marginRight: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={ArrowDown}
                    alt="Custom Icon"
                    width="18"
                    height="24"
                  />
                </Box>
              )}
              sx={{
                height: "37px",
                width: "11rem",
                color: "#20724E",
                fontWeight: "bold",
                borderRadius: "10px",
                backgroundColor: "#E5F1EB",
                border: "none",
                mr: 2,
                "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  border: "1px solid #E5F1EB",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            >
              <MenuItem value="">Department</MenuItem>
              {departmentMasterData?.map((row) => (
                <MenuItem value={row?.id}>{row?.name}</MenuItem>
              ))}
            </Select>

            <Box
              sx={{ display: "flex", alignItems: "center", gap: "5px", mr: 2 }}
            >
              <Box
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={(event) => handleClick(event)}
                sx={{
                  background: "#E5F1EB",
                  borderRadius: "8px",
                  width: "9rem",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                }}
              >
                <Typography sx={{ color: "#20724E", fontSize: "14px" }}>
                  {startDate || moment().startOf("year").format("MMM DD, YYYY")}
                </Typography>
                <img src={CalanderActive} width="20" height="20" />
              </Box>
              <Typography
                sx={{ pr: 1, pl: 1, color: "#000000", fontWeight: "600" }}
              >
                To
              </Typography>
              <Box
                aria-controls={openEnd ? "basic-menu-end" : undefined}
                aria-haspopup="true"
                aria-expanded={openEnd ? "true" : undefined}
                onClick={(event) => handleClickEnd(event)}
                sx={{
                  background: "#E5F1EB",
                  borderRadius: "8px",
                  width: "9rem",
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                }}
              >
                <Typography sx={{ color: "#20724E", fontSize: "14px" }}>
                  {endDate || moment().endOf("year").format("MMM DD, YYYY")}
                </Typography>
                <img src={CalanderActive} width="20" height="20" />
              </Box>
              {open && (
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                >
                  <DateEditCalendar
                    handleCloseCalendar={handleClose}
                    saveTheDate={handleSaveDateStart}
                    date={startDate}
                  />
                </Menu>
              )}
              {openEnd && (
                <Menu
                  id="basic-menu-end"
                  anchorEl={anchorElEnd}
                  open={openEnd}
                  onClose={handleCloseEnd}
                >
                  <DateEditCalendar
                    handleCloseCalendar={handleCloseEnd}
                    saveTheDate={handleSaveDateEnd}
                  />
                </Menu>
              )}
            </Box>
          </Box>
        </Box>
        <Divider sx={{ width: "auto" }} />

        <Box sx={{ margin: "10px 25px 20px 25px" }}>
          <TableContainer
            sx={{
              maxHeight: "620px",
              "&::-webkit-scrollbar": {
                width: "5px",
                height: "3px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#20724E",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#E5F1EB",
              },
            }}
          >
            {repairstData.length <= 0 ? (
              <Grid sx={{ paddingTop: "20px" }}>
                <Grid
                  item
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box>
                    <Box
                      component="img"
                      sx={{
                        height: "25rem",
                        width: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      alt=""
                      src={noData}
                    />
                  </Box>
                  <Box
                    fontWeight="600"
                    sx={{ padding: "20px", fontWeight: "600" }}
                  >
                    <Typography sx={{ fontWeight: "600", fontSize: "18px" }}>
                      No Data Found
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            ) : (
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Repair ID
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Vessel Name
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Checklist ID
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Department
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Created Date & Time
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#B5B5C3",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Submitted Date & time
                    </TableCell>
                    {hasPermission(
                      userData?.userRolePermission,
                      "View_Repair"
                    ) ? (
                      <TableCell
                        sx={{
                          color: "#B5B5C3",
                          fontWeight: 600,
                          whiteSpace: "nowrap",
                        }}
                      >
                        View
                      </TableCell>
                    ) : null}
                    <TableCell> </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {isLoading ? (
                    <TableRow
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        height: "10rem",
                      }}
                    >
                      <TableCell colSpan={8} align="center">
                        <CircularProgress color="success" />
                      </TableCell>
                    </TableRow>
                  ) : (
                    <>
                      {repairstData.map((row) => (
                        <TableRow
                          // key={row.Checklist}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell
                            sx={{
                              color: "#464E5F",
                              fontWeight: 600,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {GenerateRepairId(
                              row?.check_list_type_info?.vessel_info?.name,
                              row?.display_id
                            )}
                          </TableCell>
                          <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                            {row?.check_list_type_info?.vessel_info?.name}
                          </TableCell>
                          <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                            {formatRepairId(
                              row?.check_list_type_info?.vessel_info?.name,
                              row?.checklist?.department?.name,
                              row?.check_list_type_info?.checklist_type,
                              row?.check_list_type_info?.display_id
                            )}
                          </TableCell>
                          <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                            {row?.checklist?.department?.name}
                          </TableCell>
                          <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                            {moment(row?.createdAt)
                              .local()
                              .format("D MMMM, YYYY | hh:mm A")}
                          </TableCell>
                          <TableCell sx={{ color: "#464E5F", fontWeight: 600 }}>
                            {moment(row?.updatedAt)
                              .local()
                              .format("D MMMM, YYYY | hh:mm A")}
                          </TableCell>

                          {hasPermission(
                            userData?.userRolePermission,
                            "View_Repair"
                          ) ? (
                            <TableCell align="left">
                              <IconButton>
                                <img
                                  src={ViewButton}
                                  width="30"
                                  height="30"
                                  onClick={() => {
                                    setRepairDeffectRowData(row);
                                    setIsRepairsViewModel(true);
                                  }}
                                />
                              </IconButton>
                            </TableCell>
                          ) : null}
                        </TableRow>
                      ))}
                    </>
                  )}
                </TableBody>
              </Table>
            )}
          </TableContainer>
          <Divider />
          {repairstDataPagination?.totalRecord > TOTALLIMIT ? (
            <Stack
              spacing={2}
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              sx={{
                padding: "1rem",
                marginTop: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ mr: "8px" }}>Row Per Page</Typography>
                <Select
                  value={isPaginationLimit}
                  onChange={handleChangeIsPaginationLimit}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  IconComponent={() => (
                    <Box
                      sx={{
                        marginRight: "10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={ArrowDown}
                        alt="Custom Icon"
                        width="18"
                        height="24"
                      />
                    </Box>
                  )}
                  sx={{
                    height: "37px",
                    width: "6rem",
                    color: "#20724E",
                    fontWeight: "bold",
                    borderRadius: "10px",
                    border: "none",
                    backgroundColor: "#E5F1EB",
                    mr: 2,
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      border: "1px solid #E5F1EB",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={30}>30</MenuItem>
                </Select>
              </Box>
              <Box>
                <Pagination
                  count={repairstDataPagination?.totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  renderItem={(item) => (
                    <PaginationItem
                      slots={{
                        previous: ArrowBackIcon,
                        next: ArrowForwardIcon,
                      }}
                      {...item}
                    />
                  )}
                />
              </Box>
            </Stack>
          ) : null}
        </Box>
      </Paper>
    </>
  );
};

export default RepairsContent;
